export const IMAGES = {
  heroCar:
    "https://customer-assets.emergentagent.com/job_0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/artifacts/k3q420g7_inovo_head_1024x700_lexs-03.jpg",
  aboutCar:
    "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/f53zs40l_inovo_head_1024x700_500gte-04.jpg",
  services: {
    method:
      "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/4yxc0qoh_inovo_web_1280x400_about.jpg",
    model:
      "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/vv3cd0q0_inovo_designers_00.jpg",
    colocation:
      "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/zq1qyo63_inovo_design_pilato-4.jpg",
    product:
      "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/y3hk8yje_inovo_web_cosmetic-home-button.jpg",
    system:
      "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/r82j2l11_inovo_head_test-1024x700_celero-1.jpg",
  },
  brandLogos: [
    { name: "Nissan", src: "/logos/nissan.png" },
    { name: "Pilato", src: "/logos/pilato.png" },
    { name: "SsangYong", src: "/logos/ssangyong.png" },
    { name: "Trigano", src: "/logos/trigano.png" },
    { name: "New Holland", src: "/logos/new-holland.png" },
    { name: "Iveco", src: "/logos/iveco.png" },
    { name: "JAC", src: "/logos/jac.png" },
    { name: "KO Propo", src: "/logos/ko-propo.png" },
    { name: "Lancia", src: "/logos/lancia.png" },
    { name: "Maserati", src: "/logos/maserati.png" },
    { name: "Changan", src: "/logos/changan.png" },
    { name: "Fiat", src: "/logos/fiat.png" },
    { name: "Fiat Industrial", src: "/logos/fiat-industrial.png" },
    { name: "Giannini", src: "/logos/giannini.png" },
    { name: "Irisbus", src: "/logos/irisbus.png" },
    { name: "Alfa Romeo", src: "/logos/alfa-romeo.png" },
    { name: "Aprilia", src: "/logos/aprilia.png" },
    { name: "Azimut", src: "/logos/azimut.png" },
    { name: "Baralan", src: "/logos/baralan.png" },
  ],
  portfolio: [
    {
      id: "lirica-concept",
      src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/tlvxn14t_inovo_head_1024x700_lirica-02.jpg",
      client: "Inovo Design Lirica Concept",
      tag: "Car Design · 2006",
      gallery: [
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/tlvxn14t_inovo_head_1024x700_lirica-02.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/h0guo7cd_inovo_head_1024x700_lirica-06.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/rfnxlkhy_inovo_web_1280x400_lirica-02.jpg",
        },
      ],
    },
    {
      id: "trio",
      src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/xsha87xn_inovo_head_test-1024x700_trio-03.jpg",
      client: "Inovo Design Trio",
      tag: "Mobility Concept · 1998",
      gallery: [
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/xsha87xn_inovo_head_test-1024x700_trio-03.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/lsjsi9h6_inovo_head_test-1024x700_trio-01.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/m4vc5hii_inovo_head_test-1024x700_trio-02.jpg",
        },
      ],
    },
    {
      id: "rc-chassis",
      src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/l2jqes1l_inovo_web_motonica-home-button.jpg",
      client: "FASTOM Motonica",
      tag: "RC Racing 1:8 · 2007–2016",
      gallery: [
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/l2jqes1l_inovo_web_motonica-home-button.jpg",
        },
        {
          src: "https://customer-assets.emergentagent.com/job_0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/artifacts/1hwzoyob_fondo_rs2.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/t7y4elo4_inovo_head_test-1024x700_celero-0.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/achecv0q_inovo_head_test-1024x700_celero-1.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/2ajhwijy_inovo_head_test-1024x700_celero-2.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/8em00arf_inovo_head_test-1024x700_celero-3.jpg",
        },
      ],
    },
    {
      id: "ducato-van",
      src: "https://customer-assets.emergentagent.com/job_0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/artifacts/8m1rlu0t_inovo_head_test-1024x700_ducato-06.jpg",
      client: "Fiat Ducato",
      tag: "Commercial Vehicle · 2006",
      gallery: [
        {
          src: "https://customer-assets.emergentagent.com/job_0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/artifacts/8m1rlu0t_inovo_head_test-1024x700_ducato-06.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/2qura1j7_inovo_head_test-1024x700_ducato-05.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/phu5ytol_inovo_web_ducato-home-button.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/x09u9xh5_inovo_head_test-1024x700_ducato-03.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/73nk0fv8_inovo_head_test-1024x700_ducato-04.jpg",
        },
      ],
    },
    {
      id: "iveco-stralis-2005",
      src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/0meu4ebm_inovo_head_1024x700_stralis-1.jpg",
      client: "IVECO STRALIS 2005 HEAVY TRUCK",
      tag: "Heavy Truck Design · 2005",
      gallery: [
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/0meu4ebm_inovo_head_1024x700_stralis-1.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/248o02si_inovo_head_1024x700_stralis.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/zprjtiyd_inovo_web_stralis-home-button.jpg",
        },
      ],
    },
    {
      id: "fiat-idea-cinque-terre-2004",
      src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/zrfs8o2y_inovo_head_1024x700_idea5t-06.jpg",
      client: "Fiat Idea Cinque Terre",
      tag: "Full Scale Prototype · 2004",
      gallery: [
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/zrfs8o2y_inovo_head_1024x700_idea5t-06.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/zx0it9mv_inovo_head_1024x700_idea5t-05.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/zajt0fjz_inovo_head_1024x700_idea5t-04.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/3selmqia_inovo_head_1024x700_idea5t-02.jpg",
        },
      ],
    },
    {
      id: "infradito-1995",
      src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/8r6qzaq3_inovo_box-391x175px_moma-button.jpg",
      client: "Baralan Infradito",
      tag: "Product Design · 1995",
      objectPosition: "left center",
      gallery: [
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/8r6qzaq3_inovo_box-391x175px_moma-button.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/pvzyok8m_inovo_head_test-1_moma-b.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/q3qx0i99_inovo_head_1024x700_infradito02.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/2grtwnzz_inovo_head_1024x700_infradito01.jpg",
        },
      ],
    },
    {
      id: "jac-refine-m5-2012",
      src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/btvzdzsz_inovo_head_1024x700_jac-03.jpg",
      client: "JAC Refine M5 MPV",
      tag: "MPV Design · China · 2012",
      gallery: [
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/btvzdzsz_inovo_head_1024x700_jac-03.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/wlv7phrz_inovo_head_1024x700_jac-04.jpg",
        },
      ],
    },
    {
      id: "roller-team-pegaso-gtx",
      src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/lt335kzq_inovo_head_test-1024x700_trigano-06.jpg",
      client: "Roller Team Pegaso GTX",
      tag: "Motorhome Design · Trigano Group",
      gallery: [
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/zsuxm3u3_inovo_web_trigano-home-button.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/lt335kzq_inovo_head_test-1024x700_trigano-06.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/4tmpsh4x_inovo_head_test-1024x700_trigano-05.jpg",
        },
        {
          src: "https://customer-assets-v7afamib.emergentagent.net/job_creative-design-lab-8/artifacts/71a1sjo7_inovo_head_test-1024x700_trigano-02.jpg",
        },
      ],
    },
  ],
};

export const CONTENT = {
  it: {
    brands: {
      aria: "Brand con cui InovoDesign ha collaborato",
    },
    seo: {
      title: "InovoDesign — Product & Car Design Studio · dal 1995",
      description:
        "InovoDesign è uno studio di product e car design dal 1995. Uniamo cultura del progetto, design e intelligenza artificiale.",
    },
    nav: {
      about: "Studio",
      services: "Servizi",
      vision: "Vision",
      portfolio: "Portfolio",
      contact: "Contatti",
      cta: "Inizia un progetto",
    },
    hero: {
      badge: "Design Studio · dal 1995",
      titleA: "Disegniamo il",
      titleHighlight: "futuro",
      titleBPrefix: "dell'",
      titleBAccent: "e",
      titleBSuffix: "mozione.",
      subtitle:
        "InovoDesign è uno studio di product e car design nato nel 1995. Oggi uniamo l'artigianalità del progetto a un design generativo guidato dall'intelligenza artificiale.",
      ctaPrimary: "Scopri il lavoro",
      ctaSecondary: "Parla con noi",
      stat1: "Anni di esperienza",
      stat2: "Progetti realizzati",
      stat3: "Brand internazionali",
    },
    about: {
      overline: "Lo Studio",
      title: "Trent'anni di forme, una nuova intelligenza.",
      p1: "Dal 1995 trasformiamo idee in oggetti che si muovono e si usano. Abbiamo disegnato automobili, veicoli commerciali e prodotti per brand globali, con una cura maniacale per proporzione, superficie ed emozione.",
      p2: "Oggi affianchiamo alla nostra mano l'intelligenza artificiale: esplorazione generativa delle forme, ottimizzazione aerodinamica e prototipazione rapida. La tecnologia accelera, il gusto resta umano.",
      pillars: [
        { k: "1995", v: "L'anno in cui tutto è iniziato" },
        { k: "AI-Native", v: "Design generativo e iterazione rapida" },
        { k: "Made in Italy", v: "Cultura del progetto e del dettaglio" },
      ],
    },
    services: {
      overline: "Cosa facciamo",
      title: "Dal concept alla realtà.",
      items: [
        {
          title: "Car Design",
          desc: "Concept, exterior e interior per auto, supercar e veicoli commerciali. Dal bozzetto e modello 3D a maquette, studi e prototipi.",
        },
        {
          title: "Product Design",
          desc: "Oggetti industriali e di consumo pensati per funzione, ergonomia ed estetica. L'intero processo di industrializzazione viene seguito dal componente meccanico al prodotto finito.",
        },
        {
          title: "AI Driven Design",
          desc: "Esplorazione generativa, varianti infinite e ottimizzazione delle forme assistita dall'intelligenza artificiale. Benchmark strategici, moodboard ispirazionali e studi color & trim completano il processo.",
        },
        {
          title: "Consulenza brevetti",
          desc: "Consulenza internazionale per la stesura, il deposito e l'estensione all'estero di titoli di proprietà industriale. Include brevetti per invenzione, disegni e modelli ornamentali e strumenti di tutela del brand.",
        },
        {
          title: "Brand & Product Strategy",
          desc: "Allineamento tra identità di brand e scelte di forma, materiale e funzione. Un principio guida che rende ogni decisione di prodotto coerente con il significato che il brand costruisce nel tempo.",
        },
      ],
      method: {
        overline: "Metodo e fattibilità",
        title: "Il progetto procede quando visione, tempi e fattibilità si incontrano.",
        description:
          "Lavoriamo con strumenti digitali evoluti, metodi di ricerca e know-how industriale per trasformare un'intuizione in una proposta verificabile, competitiva per costi e tempi.",
        items: [
          {
            title: "Processo digitale",
            description:
              "Abbiamo adottato in modo completo la progettazione digitale già nel 2000. Oggi la maturità di hardware e software permette di esprimere qualità e precisione a livelli prima irraggiungibili, visualizzando virtualmente ogni sviluppo del prodotto anche in modalità immersiva, prima della costruzione di un modello fisico.",
          },
          {
            title: "CAS, CAD e superfici A-Class",
            description:
              "Analisi CAS e CAD accurate verificano la macro-fattibilità delle proposte. Quando necessario, accompagniamo l'ingegnerizzazione con superfici A-Class di alta qualità.",
          },
          {
            title: "Modelli e prototipi",
            description:
              "Attraverso la rete di partner realizziamo modelli reali in scala 1:1 o prototipi agili per prodotti industriali di dimensioni ridotte.",
          },
        ],
      },
      collaboration: {
        overline: "Persone e presenza",
        title: "Competenze che entrano nel processo del cliente.",
        description:
          "Talento e passione restano qualità umane decisive. Nel percorso Inovo si sono formati oltre 130 designer, alcuni dei quali guidano oggi centri di sviluppo per brand riconosciuti nel mondo. Offriamo alle industrie italiane e internazionali team in co-location, capaci di integrarsi con efficienza nei loro processi.",
        stats: [
          { value: "1999", label: "Co-location per industrie italiane e internazionali" },
          { value: "130+", label: "Designer formati nel percorso Inovo" },
        ],
        imageLabel: "Dalla ricerca digitale al modello reale",
        productLabel: "Product design e sistemi di interfaccia",
      },
    },
    vision: {
      overline: "Vision",
      title: "Una direzione condivisa rende il progetto più solido.",
      directions: [
        {
          title: "Identità che attraversa il prodotto",
          slogan: "Il brand non si applica al prodotto, lo attraversa.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/a75bb01ddb4677166f83db3ca08a34e485898ef099789f3014e1e94946ba8d01.jpeg",
        },
        {
          title: "Metodo e processo",
          slogan: "Metodo e processo non sono una sequenza di attività, ma una cultura condivisa in azienda.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/f15133abcedc951b7a61ffbbbf278d86a7331b43af9c080aac74fa12c507f143.jpeg",
        },
        {
          title: "Autorità del design",
          slogan: "Il design è più utile quando entra prima, non quando corregge dopo.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/c6470dae91d7f986beff3e7ee2d611bddd5d3e3b1d607b931f1fc4f1bc4f8a45.jpeg",
        },
        {
          title: "Know how e prodotto",
          slogan: "Il know how tecnico conta solo quando diventa un sistema di significato del prodotto.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/ce3ea2f9de01d43fddc9f0f06022800e931ff8948b69433e7f675e8a1a7552be.jpeg",
        },
        {
          title: "Design e Supply Chain",
          slogan: "La scala dei partner è una risorsa solo quando il controllo su produzione e qualità resta chiaro ed efficace.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/cd8b1e9aa0fe8143466ac6d969cb3590a8abac3da483290550c8ed86853708dc.jpeg",
        },
        {
          title: "Pensiero e Metodo",
          slogan: "Il risultato finale mostra solo una parte del valore prodotto.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/3214d7024330012e880f3ad6d668483236f38c9c0c72b7be9c32ec3242fa19df.jpeg",
        },
        {
          title: "Nuovi significati dall'intelligenza artificiale",
          slogan: "L'intelligenza artificiale non velocizza il disegno, amplia lo spazio del possibile.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/20f1adef1c5ca37721fd286028f721555d98d78eb02d0e837d413517c7772a0e.jpeg",
        },
        {
          title: "Design e rischio",
          slogan: "Il design che non rischia nulla non differenzia nulla.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/15f4b8e41d7a9ef1edbbf44477efb6671d8657fd862097f5e8c7be043be95814.jpeg",
        },
      ],
    },
    portfolio: {
      overline: "Portfolio",
      title: "Progetti selezionati.",
      confidentiality:
        "I progetti mostrati in questa pagina sono solo una parte degli oltre 200 sviluppati dal 1995 a oggi. Sono pubblicati con il consenso dei rispettivi brand; la maggior parte dei lavori resta riservata su richiesta dei clienti e non può essere mostrata pubblicamente, a tutela della loro riservatezza commerciale e industriale.",
      subtitle:
        "Una selezione di lavori realizzati per brand automotive e industriali.",
      manifestoLabel: "Dal manifesto",
      manifestoLead: "Progettare è rendere visibile una direzione.",
      openProject: "Scheda progetto",
      viewImage: "Osserva il render",
      closeLightbox: "Chiudi visualizzazione",
      previousImage: "Render precedente",
      nextImage: "Render successivo",
      imageCounter: "Render {current} di {total}",
    },
    projectPage: {
      back: "Torna al portfolio",
      caseLabel: "Scheda progetto",
      focus: "Focus",
      approach: "Approccio",
      result: "Risultato",
      closing: "Ogni progetto nasce dall'incontro tra una direzione chiara e le condizioni reali del prodotto.",
      contactCta: "Parla del tuo progetto",
      previous: "Progetto precedente",
      next: "Progetto successivo",
      gallery: "Galleria di progetto",
      story: "Approfondimento progetto",
    },
    projects: {
      "lirica-concept": {
        intro: "Presentato da Inovo Design al 76° Salone Internazionale dell'Automobile di Ginevra nel 2006, Lirica Concept è un coupé classico reinterpretato in chiave contemporanea, con un'interfaccia guidatore-vettura innovativa.",
        focus: "Dare forma a un coupé Gran Turismo italiano, rigoroso nelle proporzioni e contemporaneo nell'esperienza di bordo.",
        approach: "Il progetto combina riferimenti classici, design completamente digitale e una nuova relazione tra abitacolo, comandi e informazioni.",
        result: "Uno show car sviluppato in otto settimane, capace di sintetizzare estetica italiana, ricerca tecnologica e consulenza di design integrata.",
        chapters: [
          {
            title: "Ginevra, 2006",
            paragraphs: [
              "Inovo Design debutta al 76° Salone Internazionale dell'Automobile di Ginevra con Lirica Concept, un coupé ispirato alla tradizione classica ma interpretato con un linguaggio pienamente contemporaneo.",
              "Il progetto introduce anche una nuova interfaccia tra guidatore e automobile, pensata per rendere la tecnologia parte naturale dell'esperienza di viaggio.",
            ],
          },
          {
            title: "Filosofia del progetto",
            paragraphs: [
              "«Una villa del Settecento con arredi ultramoderni e tecnologia d'avanguardia»: questa immagine riassume lo spirito di Lirica. Il nome deriva dalla parola greca che indica un canto accompagnato dalla musica, e richiama l'idea di esprimere un messaggio artistico attraverso lo strumento tecnologico del computer.",
              "Il concept rende omaggio all'estetica e al gusto artistico italiano. È anche una sintesi dell'approccio di Inovo Design alla consulenza: dal concept iniziale alla ricerca, dallo sviluppo alla prototipazione, senza separare contenuto creativo e processo tecnico.",
              "La scelta di superare il disegno su supporto fisico a favore dei più avanzati sistemi di progettazione digitale ha ridotto tempi e costi senza sacrificare il valore creativo. Lirica è stata progettata come show car in otto settimane.",
            ],
          },
          {
            title: "Exterior design",
            paragraphs: [
              "Lirica è un grande coupé, lungo quasi cinque metri e con un passo superiore ai tre. Le proporzioni richiamano le Gran Turismo italiane di alta gamma senza ricorrere alla nostalgia: superfici ampie, pochi segni forti, cromature ridotte al minimo e una composizione sobria definiscono un'automobile contemporanea.",
              "Il powertrain prevede un motore anteriore longitudinale V8 a 90°, trazione posteriore e transaxle posteriore. L'ampia presa d'aria e i fari dal disegno tecnico costruiscono il frontale, anche nel rispetto delle norme per la protezione dei pedoni.",
              "La base del parabrezza arretrata rispetto all'asse anteriore, la linea di cintura alta, il passaruota posteriore muscoloso e l'uscita d'aria dietro la ruota anteriore costruiscono il profilo. Tetto e fiancate convergono in una coda morbida e affusolata, senza compromettere il comfort posteriore.",
            ],
          },
          {
            title: "Interior design",
            paragraphs: [
              "L'abitacolo a quattro posti ricrea l'atmosfera di un salotto italiano contemporaneo: forme essenziali, finiture di qualità, rivestimenti in Alcantara e inserti in alluminio.",
              "Il progetto ripensa ergonomia e modelli di comportamento, trasferendo una parte significativa della strumentazione dal fisico al virtuale. Al posto della plancia monolitica, un sistema multi-componente concentra comandi e informazioni principali sul volante, mentre un grande display multifunzione domina l'area centrale. Un joystick offre ai passeggeri accesso alle funzioni tecnologiche di Lirica.",
            ],
          },
        ],
      },
      trio: {
        intro: "Trio è un concept a tre ruote in cui le due ruote anteriori inclinabili seguono l'inclinazione del telaio, portando una nuova idea di sicurezza dinamica nella mobilità leggera.",
        focus: "Unire l'agilità di un veicolo compatto alla stabilità necessaria in curva e durante la frenata.",
        approach: "Il telaio coordina il movimento delle due ruote anteriori con l'inclinazione del veicolo, mettendo cinematica, controllo e percezione di guida al centro del progetto.",
        result: "Un concept brevettato che rende visibile una soluzione tecnica per una mobilità a tre ruote più sicura e controllabile.",
        chapters: [
          {
            title: "Il concept",
            paragraphs: [
              "Trio rappresenta il primo concept marciante a tre ruote sviluppato con due ruote anteriori inclinabili. Il progetto nasce dall'idea di rendere la mobilità leggera più stabile senza rinunciare a una guida diretta.",
            ],
          },
          {
            title: "Sistema inclinabile",
            paragraphs: [
              "Le due ruote anteriori seguono l'inclinazione del telaio. La soluzione permette al veicolo di affrontare curva e frenata con una base dinamica più sicura, mantenendo il comportamento del mezzo leggibile per chi guida.",
            ],
          },
          {
            title: "Brevetto",
            paragraphs: [
              "Il deposito del brevetto risale al 13 febbraio 1998. La ricerca riunisce progetto del telaio, cinematica delle sospensioni e prova del concept marciante in un'unica proposta di mobilità. Il brevetto si basa sulla particolarità di un sistema di sospensioni a quadrilateri indipendenti, uniti nei punti di fulcro e allineati con il telaio stesso.",
            ],
          },
        ],
      },
      "rc-chassis": {
        intro: "FASTOM Motonica è un progetto di automodellismo radiocomandato da competizione in scala 1:8, sviluppato all'interno di Inovo Design e divenuto un riferimento nel settore tra il 2007 e il 2016.",
        focus: "Costruire una piattaforma 1:8 on-road ad alte prestazioni, dove progettazione meccanica, messa a punto e identità del prodotto parlano lo stesso linguaggio.",
        approach: "Tecnologie derivate dall'automotive, modellazione matematica e ricerca su carbonio, geometrie e flessibilità del telaio si incontrano con una lettura digitale dei dati di gara.",
        result: "Una famiglia di modelli da competizione che ha reso FASTOM Motonica riconoscibile nell'automodellismo RC internazionale, dalla piattaforma P8.0 alle evoluzioni P81 e al sistema Celero.",
        chapters: [
          {
            title: "Una piattaforma nata in Inovo",
            paragraphs: [
              "Motonica nasce come progetto di design interno a Inovo Design nei primi anni Duemila e diventa il brand di FASTOM, orientato al segmento 1:8 on-road di alta competizione. Nel 2005 il brand viene formalizzato per portare questa cultura progettuale sul mercato internazionale.",
            ],
          },
          {
            title: "Competizione 1:8",
            paragraphs: [
              "Dalla P8.0 alla P8.0R, fino alle piattaforme P81 e P81 PRO, il progetto evolve attraverso passo, geometrie regolabili e distribuzione delle masse. Nel periodo 2007–2016 FASTOM Motonica diventa un riferimento per chi cerca precisione di guida e affidabilità in pista.",
            ],
          },
          {
            title: "Celero telemetry",
            paragraphs: [
              "Il sistema Celero estende il progetto dalla meccanica al dato. Un core di telemetria con connessione Bluetooth mette in relazione modello, sensori e interfaccia mobile, rendendo leggibili informazioni come temperatura motore e parametri di utilizzo.",
            ],
          },
          {
            title: "Materiali e messa a punto",
            paragraphs: [
              "Componenti in fibra di carbonio, elementi di irrigidimento e sistemi per la regolazione della flessibilità traducono la ricerca progettuale in possibilità concrete di tuning. La qualità del modello emerge dalla chiarezza con cui ogni dettaglio contribuisce alla prestazione.",
            ],
          },
        ],
      },
      "ducato-van": {
        intro: "Fiat Ducato, introdotto nel giugno 2006 come erede della gamma Fiat Light Commercial Vehicle, nasce dalla collaborazione tra Inovo Design e il Fiat Style Centre.",
        focus: "Reinterpretare uno dei veicoli commerciali di maggior successo del gruppo Fiat, mantenendone i caratteri distintivi e definendo un nuovo riferimento per il mercato.",
        approach: "Dieci designer Inovo lavorano a stretto contatto con i responsabili Fiat e con lo sviluppo delle superfici matematiche, dalla ricerca 2D ai modelli digitali 3D.",
        result: "Un veicolo commerciale dal design dinamico e funzionale, con CX 0,31, cabina modulare e una gamma fino a oltre 2.000 versioni.",
        chapters: [
          {
            title: "Eredità e ricerca",
            paragraphs: [
              "Ducato raccoglie l'eredità di una famiglia con oltre due milioni di unità vendute dal 1981 e una quota superiore al 31% delle vendite Fiat LCV. La ricerca avviata nel maggio 2002 coinvolge diversi Style Centre e sviluppa filoni iconici — TGV, Truck, EVO, Cubo — per esplorare differenti approcci estetici e funzionali.",
            ],
          },
          {
            title: "La proposta TGV",
            paragraphs: [
              "Dopo test comparativi e decine di modelli digitali, due proposte Inovo superano un clinic test con dealer e direzione. La direzione TGV, ispirata alla velocità e all'aerodinamica dei treni ad alta velocità, diventa il punto di partenza del nuovo Ducato.",
            ],
          },
          {
            title: "Exterior design",
            paragraphs: [
              "Il frontale contrappone un grande paraurti a un cofano compatto, creando forza e solidità senza perdere eleganza. Il paraurti grigio in tre parti riduce i costi di riparazione; griglia, fari policarbonato a tre riflettori, montante parabrezza e linee pulite contribuiscono a dinamismo, robustezza e aerodinamica.",
            ],
          },
          {
            title: "Interior e cabina mobile",
            paragraphs: [
              "La cabina è pensata come un ufficio mobile: luminosa, silenziosa, confortevole e modulare. Plancia, sedili, pannelli porta e vani per PC, mappe e telefoni favoriscono ergonomia, visibilità, comfort acustico, climatico e vibrazionale durante molte ore di guida.",
            ],
          },
          {
            title: "Una gamma configurabile",
            paragraphs: [
              "Furgoni lamierati e vetrati, cabine singole o doppie e basi per trasformazioni articolano una gamma con due classi meccaniche, tre passi, quattro lunghezze, tre altezze e configurazioni passeggeri da 5 a 32 posti. In totale, oltre 300 tipi di carrozzeria e più di 2.000 versioni disponibili.",
            ],
          },
        ],
      },
      "iveco-stralis-2005": {
        intro: "Nel 2005 Iveco rinnova la gamma Stralis, evoluzione conclusiva della propria offerta per il trasporto pesante su strada.",
        focus: "Rafforzare l'identità di un heavy truck attraverso una cabina più riconoscibile, funzionale e aerodinamicamente evoluta.",
        approach: "Inovo Design ha collaborato con l'Iveco Style Centre nel processo di sviluppo dello styling e ha curato il restyling del modello Stralis.",
        result: "Un frontale di maggiore impatto e una cabina dal carattere moderno e deciso, progettata per coniugare personalità, funzionalità e aerodinamica.",
        chapters: [
          {
            title: "Rinnovo della gamma",
            paragraphs: [
              "Stralis 2005 rappresenta il rinnovo della gamma Iveco per il trasporto pesante su gomma. Il progetto affronta l'ultima evoluzione del modello attraverso un linguaggio più netto e contemporaneo.",
            ],
          },
          {
            title: "Sviluppo dello styling",
            paragraphs: [
              "Inovo Design coopera con l'Iveco Style Centre nel processo di sviluppo dello styling e realizza per Iveco il restyling del modello Stralis.",
            ],
          },
          {
            title: "Frontale, cabina e aerodinamica",
            paragraphs: [
              "L'effetto visivo risulta più incisivo soprattutto nella vista frontale, grazie al nuovo profilo più ampio della griglia del radiatore, ai gruppi ottici integrati e al disegno del paraurti.",
              "La soluzione per la cabina costruisce un'immagine più marcata per personalità e funzionalità, moderna e aggressiva, mantenendo al centro un miglioramento della soluzione aerodinamica.",
            ],
          },
        ],
      },
      "fiat-idea-cinque-terre-2004": {
        intro: "Fiat Idea Cinque Terre è il prototipo Fiat basato su Idea, presentato nel 2004 alla 74ª edizione del Salone dell'Automobile di Ginevra.",
        focus: "Costruire un modello trasversale, capace di unire la funzionalità di un SUV alla modularità e flessibilità di un MPV.",
        approach: "Fiat Style e Inovo Design hanno sviluppato l'exterior design, traducendo il carattere off-road in assetto, livrea, materiali e dettagli.",
        result: "Un prototipo in scala reale che amplia i codici di Fiat Idea con un'identità più aperta all'uso, alla natura e alla tecnologia.",
        chapters: [
          {
            title: "Un progetto trasversale",
            paragraphs: [
              "Cinque Terre è il prototipo Fiat basato su Idea, presentato nel 2004 in occasione della 74ª edizione del Salone dell'Automobile di Ginevra.",
              "La sua caratteristica più forte è la trasversalità: mette insieme aspetti di tipologie diverse, come la funzionalità di un SUV e la modularità, con la flessibilità dell'abitacolo di un MPV.",
            ],
          },
          {
            title: "Exterior design",
            paragraphs: [
              "L'exterior design di Fiat Idea Cinque Terre è stato sviluppato da Fiat Style insieme a Inovo Design. Rispetto alla Fiat Idea di base, il progetto introduce una presenza più off-road, visibile nell'assetto rialzato e nella livrea bicolore.",
              "La vernice Rainbow Gold a triplo strato dialoga con il colore Musk delle protezioni laterali, ispirato alle tonalità della macchia mediterranea.",
            ],
          },
          {
            title: "Materiali e abitacolo",
            paragraphs: [
              "Il richiamo al mondo naturale attraversa anche i materiali: pavimento e bagagliaio sono rivestiti in fibra di cocco intrecciata; la parte superiore della plancia è morbida e porosa al tatto; i pannelli porta, nel colore Musk, accolgono inserti in Maktub che rivestono anche i sedili.",
            ],
          },
          {
            title: "Segni distintivi",
            paragraphs: [
              "I fari anteriori, con disegno a goccia e taglio obliquo inserito in una sorta di palpebra, portano un carattere hi-tech. Restano invece i grandi finestrini del modello di base, che rendono la vettura meno compatta nella percezione e migliorano visibilità e luminosità.",
            ],
          },
        ],
      },
      "infradito-1995": {
        intro: "Baralan Infradito è un progetto di product design realizzato nel 1995: un applicatore di smalto che ripensa il gesto e l'oggetto attraverso una forma essenziale e funzionale.",
        focus: "Ridisegnare l'applicazione dello smalto trasformando il contenitore in uno strumento più diretto da impugnare e utilizzare.",
        approach: "Il progetto mette in relazione ergonomia, gesto, contenitore e applicatore, concentrando la funzione in un oggetto compatto e riconoscibile.",
        result: "Un prodotto premiato con il Compasso d'Oro e tuttora esposto al Museum of Modern Art di New York.",
        chapters: [
          {
            title: "Product design, 1995",
            paragraphs: [
              "Realizzato nel 1995, Infradito affronta un oggetto quotidiano con un punto di vista progettuale: non aggiunge decorazione, ma riconsidera il rapporto tra forma, mano e azione.",
            ],
          },
          {
            title: "Un gesto ripensato",
            paragraphs: [
              "Il contenitore integra l'applicatore di smalto e si colloca tra le dita, rendendo più diretto il gesto di prelievo e applicazione. La forma compatta guida l'uso e rende immediata la relazione con il prodotto.",
            ],
          },
          {
            title: "Brevetto",
            paragraphs: [
              "La soluzione è documentata da brevetto statunitense per un contenitore con applicatore per smalto interposto tra le dita, a conferma della ricerca funzionale che sostiene il progetto.",
            ],
          },
          {
            title: "Compasso d'Oro e MoMA",
            paragraphs: [
              "Baralan Infradito è stato premiato con il Compasso d'Oro. Il progetto è ancora oggi esposto al Museum of Modern Art di New York, come testimonianza di un approccio al product design capace di unire semplicità formale e innovazione d'uso.",
            ],
          },
        ],
      },
      "jac-refine-m5-2012": {
        intro: "JAC Refine M5 MPV è un veicolo multi-purpose realizzato in Cina nel 2012 per JAC, pensato per unire capacità di trasporto, accessibilità e qualità della vita a bordo.",
        focus: "Dare a un MPV una presenza esterna ordinata e uno spazio interno capace di adattarsi a passeggeri, bagagli e usi diversi.",
        approach: "Il progetto mette in relazione proporzioni, apertura dell'abitacolo e organizzazione delle sedute, con attenzione alla leggibilità delle funzioni e al comfort percepito.",
        result: "Un MPV dal carattere contemporaneo, in cui volume, modularità e accoglienza concorrono a una proposta coerente per il mercato cinese.",
        chapters: [
          {
            title: "MPV per il mercato cinese",
            paragraphs: [
              "Realizzato in Cina nel 2012 per JAC, Refine M5 interpreta il veicolo multi-purpose come uno spazio mobile aperto a esigenze di trasporto, famiglia e lavoro.",
            ],
          },
          {
            title: "Presenza e proporzioni",
            paragraphs: [
              "Il disegno esterno costruisce un volume generoso e leggibile. Frontale, superfici laterali e vetrature definiscono un veicolo riconoscibile senza rinunciare alla praticità richiesta dalla categoria.",
            ],
          },
          {
            title: "Abitacolo modulare",
            paragraphs: [
              "Gli studi dell'interno esplorano una cabina con sedute configurabili, passaggi ampi e funzioni organizzate attorno a chi guida e a chi viaggia. Lo spazio diventa una risorsa flessibile, non un semplice contenitore.",
            ],
          },
        ],
      },
      "roller-team-pegaso-gtx": {
        intro: "Roller Team Pegaso GTX è un camper mansardato di fascia alta, progettato in collaborazione con InovoDesign per bilanciare abitabilità, stile e aerodinamica.",
        focus: "Portare spazi familiari generosi in un veicolo di circa 7,30 metri, senza rinunciare a una presenza esterna fluida e moderna.",
        approach: "Il progetto lavora sulla mansarda, sulla distribuzione interna e sui dettagli della cabina per coordinare volume, comfort e scorrimento dell'aria su telaio Fiat Ducato 3.0 Multijet da 160 CV.",
        result: "Un motorhome premium riconoscibile, con dinette avanzata, bagno con doccia separata e un grande garage posteriore per l'attrezzatura di viaggio.",
        chapters: [
          {
            title: "Il modello Pegaso GTX",
            paragraphs: [
              "Pegaso GTX è un camper mansardato di fascia alta che si distingue per l'equilibrio tra abitabilità e aerodinamica. La mansarda fluida, progettata con InovoDesign, contribuisce a ridurre l'attrito con l'aria.",
              "Sviluppato su telaio Fiat Ducato 3.0 Multijet da 160 CV e lungo circa 7,30 metri, offre spazi interni generosi pensati per l'uso familiare.",
            ],
          },
          {
            title: "Spazi per il viaggio",
            paragraphs: [
              "La dinette avanzata, il bagno con doccia separata e il grande garage posteriore compongono un'organizzazione interna orientata a comfort, autonomia e trasporto di attrezzature ingombranti.",
              "Gli studi foto e 3D mostrano il dialogo tra interni reali e proposta progettuale, dalla distribuzione degli arredi alla qualità percepita dei materiali.",
            ],
          },
          {
            title: "Il brand Roller Team",
            paragraphs: [
              "Roller Team è un marchio italiano del settore plein air, nato nel distretto della camperistica toscana. Il suo posizionamento unisce design moderno, stile italiano e un rapporto qualità-prezzo competitivo.",
              "Con la serie Pegaso, il brand ha presidiato la fascia premium attraverso dotazioni e finiture di alto livello.",
            ],
          },
          {
            title: "Successo commerciale",
            paragraphs: [
              "La combinazione tra meccanica Fiat 3.0 potente e affidabile e volumetrie interne molto ampie ha contribuito al successo del Pegaso GTX sul mercato.",
              "Il modello è ancora ricercato e mantiene un elevato valore residuo nel mercato dell'usato.",
            ],
          },
        ],
      },
    },
    contact: {
      overline: "Contatti",
      title: "Hai un progetto in mente?",
      subtitle:
        "Raccontaci la tua idea. Trasformiamo visioni in forme che lasciano il segno.",
      name: "Nome",
      email: "Email",
      message: "Messaggio",
      send: "Invia messaggio",
      direct: "SCRIVICI DIRETTAMENTE",
    },
    footer: {
      tagline: "Product & Car Design Studio · dal 1995",
      confidentiality:
        "Progetti pubblicati con il consenso dei brand coinvolti. Molti lavori restano riservati per motivi di riservatezza industriale dei clienti.",
      rights: "Tutti i diritti riservati.",
    },
  },
  en: {
    brands: {
      aria: "Brands InovoDesign has collaborated with",
    },
    seo: {
      title: "InovoDesign — Product & Car Design Studio · since 1995",
      description:
        "InovoDesign is a product and car design studio founded in 1995, bringing together design culture, engineering and artificial intelligence.",
    },
    nav: {
      about: "Studio",
      services: "Services",
      vision: "Vision",
      portfolio: "Portfolio",
      contact: "Contact",
      cta: "Start a project",
    },
    hero: {
      badge: "Design Studio · since 1995",
      titleA: "We design the",
      titleHighlight: "future",
      titleBPrefix: "of ",
      titleBAccent: "e",
      titleBSuffix: "motion.",
      subtitle:
        "InovoDesign is a product and car design studio founded in 1995. Today we are reborn, blending craftsmanship with generative design powered by artificial intelligence.",
      ctaPrimary: "Explore our work",
      ctaSecondary: "Talk to us",
      stat1: "Years of experience",
      stat2: "Projects delivered",
      stat3: "International brands",
    },
    about: {
      overline: "The Studio",
      title: "Thirty years of forms, a new intelligence.",
      p1: "Since 1995 we have turned ideas into objects that move and that people use. We have designed cars, commercial vehicles and products for global brands, with an obsessive care for proportion, surface and emotion.",
      p2: "Today we pair our hands with artificial intelligence: generative form exploration, aerodynamic optimization and rapid prototyping. Technology accelerates, taste stays human.",
      pillars: [
        { k: "1995", v: "The year it all began" },
        { k: "AI-Native", v: "Generative design and rapid iteration" },
        { k: "Made in Italy", v: "Design culture and attention to detail" },
      ],
    },
    services: {
      overline: "What we do",
      title: "From concept to reality.",
      items: [
        {
          title: "Car Design",
          desc: "Concept, exterior and interior for cars, supercars and commercial vehicles. From sketch and 3D model to maquettes, design studies and prototypes.",
        },
        {
          title: "Product Design",
          desc: "Industrial and consumer objects built around function, ergonomics and aesthetics. The entire industrialization process is managed from the mechanical part to the finished product.",
        },
        {
          title: "AI Driven Design",
          desc: "Generative exploration, limitless variants and AI-assisted form optimization. Strategic benchmarking, inspirational mood boards and colour & trim studies complete the process.",
        },
        {
          title: "Patent consulting",
          desc: "International consulting for drafting, filing and foreign extension of industrial-property rights. It includes invention patents, ornamental designs and models, and brand-protection instruments.",
        },
        {
          title: "Brand & Product Strategy",
          desc: "Alignment between brand identity and choices of form, material and function. A guiding principle that keeps every product decision coherent with the meaning the brand builds over time.",
        },
      ],
      method: {
        overline: "Method and feasibility",
        title: "A project moves forward when vision, timing and feasibility meet.",
        description:
          "We work with advanced digital tools, research methods and industrial know-how to turn an intuition into a proposal that can be verified and remain competitive in cost and time.",
        items: [
          {
            title: "Digital process",
            description:
              "We fully adopted digital design as early as 2000. Today, the maturity of hardware and software makes it possible to express quality and precision at previously unreachable levels, while allowing every product development to be visualized virtually and in immersive modes before a physical model is built.",
          },
          {
            title: "CAS, CAD and A-Class surfacing",
            description:
              "Accurate CAS and CAD analysis validates the macro-feasibility of each proposal. When required, we support engineering with high-quality A-Class surfaces.",
          },
          {
            title: "Models and prototypes",
            description:
              "Through our partner network, we produce full-scale real models or agile prototypes for smaller industrial products.",
          },
        ],
      },
      collaboration: {
        overline: "People and presence",
        title: "Capabilities that enter the client’s process.",
        description:
          "Talent and passion remain decisive human qualities. More than 130 designers have grown through the Inovo journey, with some now leading development centres for brands recognized around the world. We offer Italian and international industries co-location teams that can integrate efficiently into their processes.",
        stats: [
          { value: "1999", label: "Co-location for Italian and international industries" },
          { value: "130+", label: "Designers grown through the Inovo journey" },
        ],
        imageLabel: "From digital research to the real model",
        productLabel: "Product design and interface systems",
      },
    },
    vision: {
      overline: "Vision",
      title: "A shared direction makes a stronger product.",
      directions: [
        {
          title: "Identity that runs through the product",
          slogan: "A brand is not applied to a product, it runs through it.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/a75bb01ddb4677166f83db3ca08a34e485898ef099789f3014e1e94946ba8d01.jpeg",
        },
        {
          title: "Method and process",
          slogan: "Method and process are not a sequence of activities, but a shared culture within a company.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/f15133abcedc951b7a61ffbbbf278d86a7331b43af9c080aac74fa12c507f143.jpeg",
        },
        {
          title: "Design authority",
          slogan: "Design is most useful when it enters early, not when it corrects later.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/c6470dae91d7f986beff3e7ee2d611bddd5d3e3b1d607b931f1fc4f1bc4f8a45.jpeg",
        },
        {
          title: "Know how and product",
          slogan: "Technical know how matters only when it becomes a system of meaning within the product.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/ce3ea2f9de01d43fddc9f0f06022800e931ff8948b69433e7f675e8a1a7552be.jpeg",
        },
        {
          title: "Design and Supply Chain",
          slogan: "Partners’ scale is a resource only when control over production and quality remains clear and effective.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/cd8b1e9aa0fe8143466ac6d969cb3590a8abac3da483290550c8ed86853708dc.jpeg",
        },
        {
          title: "Thought and method",
          slogan: "The final result reveals only part of the value created.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/3214d7024330012e880f3ad6d668483236f38c9c0c72b7be9c32ec3242fa19df.jpeg",
        },
        {
          title: "New meanings from artificial intelligence",
          slogan: "Artificial intelligence does not speed up drawing, it expands the space of the possible.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/20f1adef1c5ca37721fd286028f721555d98d78eb02d0e837d413517c7772a0e.jpeg",
        },
        {
          title: "Design and risk",
          slogan: "Design that risks nothing differentiates nothing.",
          image: "https://static.prod-images.emergentagent.com/jobs/0f25c9f5-6442-4349-9e14-1d2bd0cdd84d/images/15f4b8e41d7a9ef1edbbf44477efb6671d8657fd862097f5e8c7be043be95814.jpeg",
        },
      ],
    },
    portfolio: {
      overline: "Portfolio",
      title: "Selected projects.",
      confidentiality:
        "The projects shown on this page are only part of the more than 200 developed since 1995. They are published with the consent of the respective brands; most work remains confidential at clients’ request and cannot be shown publicly, to protect their commercial and industrial confidentiality.",
      subtitle: "A selection of work delivered for automotive and industrial brands.",
      manifestoLabel: "From the manifesto",
      manifestoLead: "Design makes a direction visible.",
      openProject: "Project note",
      viewImage: "View render",
      closeLightbox: "Close viewer",
      previousImage: "Previous render",
      nextImage: "Next render",
      imageCounter: "Render {current} of {total}",
    },
    projectPage: {
      back: "Back to portfolio",
      caseLabel: "Project note",
      focus: "Focus",
      approach: "Approach",
      result: "Outcome",
      closing: "Every project begins where a clear direction meets the real conditions of a product.",
      contactCta: "Discuss your project",
      previous: "Previous project",
      next: "Next project",
      gallery: "Project gallery",
      story: "Project narrative",
    },
    projects: {
      "lirica-concept": {
        intro: "Presented by Inovo Design at the 76th International Motor Show in Geneva in 2006, Lirica Concept is a classically-inspired coupé interpreted in a contemporary key, with an innovative driver–car interface.",
        focus: "Giving form to an Italian Gran Turismo coupé, rigorous in proportion and contemporary in its onboard experience.",
        approach: "The project combines classical references, fully digital design and a new relationship between cabin, controls and information.",
        result: "A show car designed in eight weeks, bringing together Italian aesthetics, technological research and integrated design consulting.",
        chapters: [
          {
            title: "Geneva, 2006",
            paragraphs: [
              "Inovo Design made its debut appearance at the 76th International Motor Show in Geneva with Lirica Concept: a coupé inspired by the classical tradition, but interpreted in a contemporary key.",
              "The project also unveiled an innovative driver–car interface, conceived to make technology a natural part of the travel experience.",
            ],
          },
          {
            title: "Project philosophy",
            paragraphs: [
              "“An eighteenth-century villa with ultramodern décor and cutting-edge technology.” This image sums up the spirit of Lirica. Its name comes from the Greek word for a song with musical accompaniment, evoking the ambition to express an artistic message through the technological instrument of the computer.",
              "The concept pays homage to Italian aesthetics and artistic taste. It also synthesizes Inovo Design’s approach to consulting: from initial concept to research, project development and prototyping, without separating creative content from technical process.",
              "Choosing to move beyond hardcopy design and towards advanced computer design systems reduced time and cost without compromising creative value. Lirica was designed as a show car in eight weeks.",
            ],
          },
          {
            title: "Exterior design",
            paragraphs: [
              "Lirica is a large coupé, nearly five metres long with a wheelbase of more than three. Its proportions honour the tradition of the luxury Italian Gran Turismo without resorting to retro nostalgia: broad surfaces, a few strong features, minimal chrome and a sober composition define a contemporary automobile.",
              "The powertrain is based on a longitudinal front-mounted 90° V8, rear-wheel drive and a rear transaxle. A large air intake and highly technical headlamps form the front end, also in compliance with pedestrian-protection standards.",
              "The windscreen base sits behind the front axle, with a high belt line, muscular rear fender and an air outlet behind the front wheel. The sides and roof line converge into a soft, tapered rear form without compromising rear passenger comfort.",
            ],
          },
          {
            title: "Interior design",
            paragraphs: [
              "The four-seat cabin recreates the atmosphere of a contemporary Italian salon through essential forms, high-quality finishes, Alcantara upholstery and aluminium inserts.",
              "The design rethinks ergonomics and behavioural models, moving a significant part of the instrumentation from the physical into the virtual world. Instead of a monolithic dashboard, a multi-component system centres the main controls and driver information on the steering wheel while a large multifunction display dominates the central area. A joystick gives passengers access to Lirica’s technological features.",
            ],
          },
        ],
      },
      trio: {
        intro: "Trio is a three-wheel concept in which two tilting front wheels follow the inclination of the chassis, bringing a new idea of dynamic safety to light mobility.",
        focus: "Combining the agility of a compact vehicle with the stability required during cornering and braking.",
        approach: "The chassis coordinates the movement of the two front wheels with the vehicle’s inclination, placing kinematics, control and driving perception at the centre of the project.",
        result: "A patented concept that makes a technical solution for safer, more controllable three-wheel mobility visible.",
        chapters: [
          {
            title: "The concept",
            paragraphs: [
              "Trio represents the first running three-wheel concept developed with two tilting front wheels. The project began from the idea of making light mobility more stable without giving up direct driving.",
            ],
          },
          {
            title: "Tilting system",
            paragraphs: [
              "The two front wheels follow the inclination of the chassis. The solution lets the vehicle tackle cornering and braking with a safer dynamic base, while keeping its behaviour legible to the rider.",
            ],
          },
          {
            title: "Patent",
            paragraphs: [
              "The patent was filed on 13 February 1998. The research brings chassis design, suspension kinematics and testing of a running concept together in one mobility proposal. The patent is based on the distinctive use of independent double-wishbone suspensions, joined at their pivot points and aligned with the chassis itself.",
            ],
          },
        ],
      },
      "rc-chassis": {
        intro: "FASTOM Motonica is a 1:8-scale radio-controlled racing project developed within Inovo Design, which became a reference in the field from 2007 to 2016.",
        focus: "Building a high-performance 1:8 on-road platform where mechanical design, setup and product identity speak the same language.",
        approach: "Automotive-derived technologies, mathematical modelling and research into carbon fibre, geometry and chassis flex meet a digital reading of race data.",
        result: "A family of racing models that made FASTOM Motonica recognizable in international RC racing, from the P8.0 platform through the P81 evolutions and the Celero system.",
        chapters: [
          {
            title: "A platform born at Inovo",
            paragraphs: [
              "Motonica began as an internal design project at Inovo Design in the early 2000s and became FASTOM’s brand for the high-competition 1:8 on-road segment. In 2005 the brand was formalized to bring this design culture to the international market.",
            ],
          },
          {
            title: "1:8 competition",
            paragraphs: [
              "From P8.0 to P8.0R and then the P81 and P81 PRO platforms, the project evolved through wheelbase, adjustable geometry and weight distribution. Over 2007–2016, FASTOM Motonica became a reference for drivers seeking precise handling and track reliability.",
            ],
          },
          {
            title: "Celero telemetry",
            paragraphs: [
              "The Celero system extends the project from mechanics to data. A telemetry core with Bluetooth connectivity links model, sensors and mobile interface, making information such as engine temperature and usage parameters legible.",
            ],
          },
          {
            title: "Materials and setup",
            paragraphs: [
              "Carbon-fibre components, bracing elements and chassis-flex adjustment systems turn design research into concrete tuning possibilities. The quality of the model emerges from how clearly each detail contributes to performance.",
            ],
          },
        ],
      },
      "ducato-van": {
        intro: "Fiat Ducato, introduced in June 2006 as heir to the Fiat Light Commercial Vehicle range, was developed through a collaboration between Inovo Design and the Fiat Style Centre.",
        focus: "Reinterpreting one of the Fiat group’s most successful commercial vehicles while retaining its defining qualities and setting a new market benchmark.",
        approach: "Ten Inovo designers worked closely with Fiat managers and the mathematical-surface development team, from 2D research through 3D digital models.",
        result: "A dynamic, functional commercial vehicle with a 0.31 drag coefficient, modular cockpit and a range of more than 2,000 versions.",
        chapters: [
          {
            title: "Heritage and research",
            paragraphs: [
              "Ducato builds on a family with more than two million units sold since 1981 and over 31% of Fiat LCV sales. Research started in May 2002 involved several Style Centres and developed icon directions — TGV, Truck, EVO, Cubo — to explore different aesthetic and functional approaches.",
            ],
          },
          {
            title: "The TGV proposal",
            paragraphs: [
              "After comparative tests and dozens of digital models, two Inovo proposals succeeded in a clinic test with dealers and management. The TGV direction, inspired by the speed and aerodynamics of high-speed trains, became the starting point for the new Ducato.",
            ],
          },
          {
            title: "Exterior design",
            paragraphs: [
              "The front contrasts a large bumper with a compact bonnet, creating strength and solidity without losing elegance. The three-part grey bumper reduces repair costs; grille, three-reflector polycarbonate headlamps, windscreen pillar and clean lines contribute to dynamism, robustness and aerodynamics.",
            ],
          },
          {
            title: "Interior and mobile cabin",
            paragraphs: [
              "The cabin is conceived as a mobile office: bright, quiet, comfortable and modular. Dashboard, seats, door panels and storage for PCs, maps and phones support ergonomics, visibility, acoustic, climatic and vibrational comfort during long driving hours.",
            ],
          },
          {
            title: "A configurable range",
            paragraphs: [
              "Paneled and glazed vans, single or double cabs and conversion bases build a range with two mechanical classes, three wheelbases, four lengths, three heights and passenger configurations from 5 to 32 seats. In total, more than 300 body types and over 2,000 versions were available.",
            ],
          },
        ],
      },
      "iveco-stralis-2005": {
        intro: "In 2005, Iveco renewed the Stralis range, the final evolution of its offer for heavy transportation on tyres.",
        focus: "Strengthening a heavy truck’s identity through a cabin that is more recognizable, functional and aerodynamically evolved.",
        approach: "Inovo Design cooperated with the Iveco Style Centre in the styling development process and carried out the restyling of the Stralis model.",
        result: "A more impactful front view and a cabin with a modern, assertive character, designed to unite personality, function and aerodynamics.",
        chapters: [
          {
            title: "Renewing the range",
            paragraphs: [
              "Stralis 2005 renewed the Iveco range, representing the final evolution in its offer for heavy transportation on tyres. The project approached the model through a sharper, more contemporary language.",
            ],
          },
          {
            title: "Styling development",
            paragraphs: [
              "Inovo Design cooperated with the Iveco Style Centre in the styling development process and carried out the restyling of the Stralis model for Iveco.",
            ],
          },
          {
            title: "Front, cabin and aerodynamics",
            paragraphs: [
              "The result is more impactful from the front, thanks to a wider new profile for the radiator grille, integrated light groups and a newly designed bumper.",
              "The solution for the cabin creates a more distinctive image in terms of personality and functionality: modern and assertive, while remaining focused on an improved aerodynamic solution.",
            ],
          },
        ],
      },
      "fiat-idea-cinque-terre-2004": {
        intro: "Fiat Idea Cinque Terre is the Fiat prototype based on the Idea, presented in 2004 at the 74th edition of the Automotive Salon in Geneva.",
        focus: "Creating a cross-disciplinary model that brings together the functional character of an SUV with the modularity and flexibility of an MPV.",
        approach: "Fiat Style and Inovo Design developed the exterior design, translating an off-road character into stance, livery, materials and details.",
        result: "A full-scale prototype that extends the Fiat Idea’s codes with an identity more open to use, nature and technology.",
        chapters: [
          {
            title: "A transversal project",
            paragraphs: [
              "Cinque Terre is the Fiat prototype based on the Idea, presented in 2004 on the occasion of the 74th edition of the Automotive Salon in Geneva.",
              "Its strongest characteristic is its transversal nature: it brings together aspects of different vehicle types, such as the functional side of an SUV with the modularity and flexibility of an MPV interior.",
            ],
          },
          {
            title: "Exterior design",
            paragraphs: [
              "The exterior design of Fiat Idea Cinque Terre was developed by Fiat Style together with Inovo Design. Compared with the base Fiat Idea, the project introduces a more off-road presence, visible in the higher stance and two-colour livery.",
              "The triple-layered Rainbow Gold paint is paired with the Musk colour of the side protections, inspired by the colours of the Mediterranean scrub.",
            ],
          },
          {
            title: "Materials and interior",
            paragraphs: [
              "The reference to the natural world also runs through the materials: floor and trunk are covered in woven coconut; the upper dashboard feels soft and porous to the touch; the Musk-coloured door panels feature Maktub inserts, which also cover the seats.",
            ],
          },
          {
            title: "Distinctive features",
            paragraphs: [
              "The front headlights, with their teardrop design and oblique cut inside a kind of eyelid, convey a hi-tech character. The large windows of the basic model remain, making the vehicle appear less compact and improving visibility and brightness.",
            ],
          },
        ],
      },
      "infradito-1995": {
        intro: "Baralan Infradito is a product design project created in 1995: a nail-varnish applicator that rethinks both the gesture and the object through an essential, functional form.",
        focus: "Redesigning nail-varnish application by turning the container into a more direct tool to hold and use.",
        approach: "The project brings together ergonomics, gesture, container and applicator, concentrating function in a compact, recognizable object.",
        result: "A product awarded the Compasso d’Oro and still displayed at the Museum of Modern Art in New York.",
        chapters: [
          {
            title: "Product design, 1995",
            paragraphs: [
              "Created in 1995, Infradito approaches an everyday object from a design perspective: it does not add decoration, but reconsiders the relationship between form, hand and action.",
            ],
          },
          {
            title: "Rethinking a gesture",
            paragraphs: [
              "The container integrates the nail-varnish applicator and sits between the fingers, making the act of taking and applying the varnish more direct. Its compact form guides use and makes the relationship with the product immediate.",
            ],
          },
          {
            title: "Patent",
            paragraphs: [
              "The solution is documented by a United States patent for a nail-varnish container with an applicator positioned between the fingers, confirming the functional research behind the project.",
            ],
          },
          {
            title: "Compasso d’Oro and MoMA",
            paragraphs: [
              "Baralan Infradito was awarded the Compasso d’Oro. The project is still displayed at the Museum of Modern Art in New York, showing an approach to product design that joins formal simplicity with innovation in use.",
            ],
          },
        ],
      },
      "jac-refine-m5-2012": {
        intro: "JAC Refine M5 MPV is a multi-purpose vehicle made in China in 2012 for JAC, conceived to bring together transport capacity, accessibility and quality of life on board.",
        focus: "Giving an MPV an orderly external presence and an interior space that can adapt to passengers, luggage and different uses.",
        approach: "The project brings together proportion, cabin openness and seat organization, with attention to legible functions and perceived comfort.",
        result: "A contemporary MPV where volume, modularity and hospitality combine into a coherent proposal for the Chinese market.",
        chapters: [
          {
            title: "An MPV for the Chinese market",
            paragraphs: [
              "Made in China in 2012 for JAC, Refine M5 approaches the multi-purpose vehicle as a mobile space open to transport, family and work needs.",
            ],
          },
          {
            title: "Presence and proportion",
            paragraphs: [
              "The exterior design creates a generous, legible volume. The front, side surfaces and glazing define a recognizable vehicle without giving up the practicality expected of the category.",
            ],
          },
          {
            title: "A modular cabin",
            paragraphs: [
              "The interior studies explore a cabin with configurable seating, broad passages and functions organized around drivers and passengers. Space becomes a flexible resource, not simply a container.",
            ],
          },
        ],
      },
      "roller-team-pegaso-gtx": {
        intro: "Roller Team Pegaso GTX is a high-end overcab motorhome, designed in collaboration with InovoDesign to balance habitability, style and aerodynamics.",
        focus: "Bringing generous family space into a vehicle around 7.30 metres long without giving up a fluid, modern exterior presence.",
        approach: "The project works across the overcab section, interior layout and cabin details to coordinate volume, comfort and airflow on a 160 hp Fiat Ducato 3.0 Multijet chassis.",
        result: "A recognizable premium motorhome, with a forward dinette, bathroom with separate shower and large rear garage for travel equipment.",
        chapters: [
          {
            title: "The Pegaso GTX model",
            paragraphs: [
              "Pegaso GTX is a high-end overcab motorhome distinguished by its balance of habitability and aerodynamics. The fluid overcab section, designed with InovoDesign, helps reduce aerodynamic drag.",
              "Developed on a 160 hp Fiat Ducato 3.0 Multijet chassis and measuring around 7.30 metres long, it offers generous interior space designed for family use.",
            ],
          },
          {
            title: "Travel spaces",
            paragraphs: [
              "The forward dinette, bathroom with separate shower and large rear garage create an interior organization focused on comfort, autonomy and carrying bulky equipment.",
              "Photography and 3D studies reveal the dialogue between the realized interior and design proposal, from furniture layout to the perceived quality of materials.",
            ],
          },
          {
            title: "The Roller Team brand",
            paragraphs: [
              "Roller Team is an Italian outdoor-living brand born in Tuscany’s motorhome district. Its positioning brings together modern design, Italian style and competitive value for money.",
              "With the Pegaso series, the brand has reached the premium segment through high-level equipment and finishes.",
            ],
          },
          {
            title: "Commercial success",
            paragraphs: [
              "The combination of powerful, reliable Fiat 3.0 mechanics and highly generous interior volumes contributed to Pegaso GTX’s success in the market.",
              "The model remains sought after and retains a high residual value in the used market.",
            ],
          },
        ],
      },
    },
    contact: {
      overline: "Contact",
      title: "Got a project in mind?",
      subtitle:
        "Tell us about your idea. We turn visions into forms that leave a mark.",
      name: "Name",
      email: "Email",
      message: "Message",
      send: "Send message",
      direct: "WRITE TO US DIRECTLY",
    },
    footer: {
      tagline: "Product & Car Design Studio · since 1995",
      confidentiality:
        "Projects are published with the consent of the brands involved. Many works remain confidential to protect clients’ industrial confidentiality.",
      rights: "All rights reserved.",
    },
  },
};

export const STUDIO = {
  email: "info@inovodesign.it",
  name: "InovoDesign",
  founded: 1995,
};
